import { Component } from '@angular/core';

@Component({
  selector: 'rnpl-finishing',
  templateUrl: './finishing.component.html',
  styleUrls: ['./finishing.component.scss'],
})
export class FinishingComponent { }
